<template>
    <div class="max-w-sm mx-auto">
        <h2 class="text-center mb-8">Notifications</h2>


    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>

</style>